/**
 * AddIdColumn Handler для Table
 * 
 * Додає колонку ID в таблицю
 * 
 * Налаштування через crudContext.settings:
 * - tableIsIdColumnHide: boolean - приховати колонку ID
 * - tableIdColumnPosition: 'start' | 'end' - позиція колонки (за замовчуванням 'start')
 * - tableIdColumnWidth: number - ширина колонки (за замовчуванням 80)
 * - tableIdColumnTitle: string - заголовок колонки (за замовчуванням 'ID')
 */

/**
 * Додає колонку ID
 * 
 * @param params - об'єкт з параметрами
 * @param params.columns - масив колонок таблиці
 * @param params.tableContext - контекст таблиці
 */
export const AddIdColumn = ({ columns, tableContext }: { columns: any[], tableContext: any }) => {
    const crudContext = tableContext.storages?.crudContext
    
    if (crudContext?.settings?.tableIsIdColumnHide === true) return columns
    
    if (columns.filter((column) => column.key === 'id').length === 0) {
        const position = crudContext?.settings?.tableIdColumnPosition ?? 'start'
        const width = crudContext?.settings?.tableIdColumnWidth ?? 80
        const title = crudContext?.settings?.tableIdColumnTitle ?? 'ID'
        
        const idColumn = {
            title,
            dataIndex: 'id',
            key: 'id',
            width,
        }
        
        if (position === 'end') {
            columns.push(idColumn)
        } else {
            columns.unshift(idColumn)
        }
    }
    return columns
}
